import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { kearneyConfig } from "./data";

export default function KearneyPage() {
  return <CityPageTemplate config={kearneyConfig} />;
}